var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"tw-text-2xl lg:tw-text-5xl tw-font-bold tw-text-ci-gray-700"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }